const getters = {
  getUrlDomain: state => state.url_domain,
  getAuthData: state => state.auth_data,
  getStoreData: state => state.store_data,
  getCustomerData: state => state.customer_data,
  orderData: state => state.order_data,
  dataCartReservation: state => state.data_cart_reservation,
  getLoadingAxiosState: (state) => state.loading_axios,
  errorType: state => state.error_type,
  errorMessage: state => state.error_message,
  showError: state => state.show_error,
  getPayment: state => state.payment,
  dataVerification: state => state.data_verification,
  getRouterData: state => state.router_data,
  getLastRouterData: (state) => {
    return state.router_data[state.router_data.length - 1]
  },
  getQueryRouter: state => state.query_router,
  subTotalReservationPrice: (state) => {
    return state.data_cart_reservation.reduce((total, item) => {
      const specialPrice = item?.special_price?.with_special_price === 1 ? parseFloat(item.special_price.special_price) : parseFloat(item.item_place_reservation.price);
      const price = specialPrice || 0;
      return total + price;
    }, 0);
  },
  adminFee: (state, getters) => {
    const adminFeePercentage = getters.getStoreData?.setting?.trans_fee_rate_place_reservation; // 1% admin fee
    const discount_amount = 0
    return getters.subTotalReservationPrice * (parseFloat(adminFeePercentage) - discount_amount);
  },
  reservationTax: (state, getters) => {
    const totalWithAdminFee = getters.subTotalReservationPrice + getters.adminFee;
    const discount_amount = 0
    // const taxRate = getters.getStoreData?.tax_rate; // 10% pajak

    const taxRate = 0
    return totalWithAdminFee * (parseFloat(taxRate) - discount_amount);
  },
  totalReservationPrice: (state, getters) => {
    const total = getters.subTotalReservationPrice + getters.adminFee + getters.reservationTax;
    return total
  },
}
export default getters
